<template>
    <div id="zynocx">
        <router-view />
        <OverlayContainer />
    </div>
</template>

<script lang="ts" setup>
import './cx.styles.css';
import { OverlayContainer } from '@zyno-io/vue-foundation';
</script>
